module.exports = __webpack_public_path__ + "static/roboto-v29-latin-regular-dc3e086fc0c5addc09702e111d2adb42.woff";